import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import navigation from '../data/navigation/navigation.json';
import footer from '../data/navigation/footer.json';

export const getAllMenus = (persona: string) => {
  const data: any = navigation['data'];
  return data[persona];
};

export const getAllFooterData = (persona: string) => {
  const data: any = footer['data'];
  return data[persona];
};

export const getMenuIcon = (type?: string) => {
  switch (type) {
    case 'home':
      return light('home');
    case 'clipboard-list':
      return light('clipboard-list');
    case 'user-gear':
      return light('user-gear');
    case 'file-magnifying-glass':
      return light('file-magnifying-glass');   
    case 'briefcase-medical':
      return light('briefcase-medical');
    case 'money-check-dollar':
      return light('money-check-dollar');
    case 'baby-carriage':
      return light('baby-carriage');
    case 'sack-dollar':
      return light('sack-dollar');
    case 'envelope-open-dollar':
      return light('envelope-open-dollar');
    case 'hand-holding-dollar':
      return light('hand-holding-dollar');
    case 'books':
      return light('books');
    case 'chart-pie':
      return light('chart-pie');
    case 'person-cane':
      return light('person-cane');
    case 'money-from-bracket':
      return light('money-from-bracket');
    case 'money-bill':
      return light('money-bill');
    default:
      return light('image-slash');
  }
};
